"use client";

import noEntryAnimation from "@/public/lottie-animations/no-entry-animation.json";
import { useTranslations } from "@frontend/lib/next-intl-typed";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import {
  useInsuranceConnectorContext,
  useInsuranceConnectorSend,
} from "../insurance-connector-provider";
import { getUnderAgeRejectionAge } from "../machine/guards/config.guard";

export function EligibilityAgeRejection() {
  const t = useTranslations("InsuranceConnector");
  const context = useInsuranceConnectorContext();
  const send = useInsuranceConnectorSend();

  return (
    <div className="flex flex-col justify-between h-full pt-2 md:pt-[48px]">
      <div className="space-y-6">
        <div className="w-20 h-20">
          <Lottie animationData={noEntryAnimation} loop={false} />
        </div>
        <h2 className="text-[28px] md:text-4xl leading-[110%] tracking-[-0.02em] font-semibold">
          {t("AgeRestriction", {
            orgName: context.orgName,
            age: getUnderAgeRejectionAge(context) ?? 18,
          })}
        </h2>
      </div>

      <div className="flex justify-end mt-6">
        <motion.button
          type="button"
          onClick={() => send({ type: "DISMISS" })}
          className="rounded-full font-medium text-white px-[53px] md:px-[48px] py-5 md:py-[20px] text-base md:text-xl md:w-auto"
          initial={{ backgroundColor: "#000000" }}
          whileHover={{ backgroundColor: "#00A3FF" }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          {t("Dismiss")}
        </motion.button>
      </div>
    </div>
  );
}
